import { ethers } from "ethers";

export const provider = new ethers.JsonRpcProvider(
  process.env.REACT_APP_RPC_PROVIDER
);
// export const ethereumProvider = new ethers.JsonRpcProvider(
//   process.env.REACT_APP_ETHEREUM_PROVIDER
// );
